<template>
  <input ref="select" />
</template>

<script>
import TomSelect from 'tom-select';
import * as accountOptionsApi from '@/api/accountOptions';

export default {
  emits: ['update:model-value', 'account-selected'],
  props: {
    modelValue: {},
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const control = new TomSelect(this.$refs.select, {
        maxItems: 1,
        valueField: 'id',
        labelField: 'label',
        searchField: 'label',
        load: (query, callback) => {
          accountOptionsApi.index({ filter: query }).then(({ options }) => {
            callback(options);
          });
        },
        onChange: value => {
          const selectedOption = control.options[value] || null;
          this.$emit('update:model-value', value);
          this.$emit('account-selected', selectedOption);
        },
      });
      if (this.modelValue) {
        accountOptionsApi.show(this.modelValue).then(option => {
          control.addOption(option);
          control.addItem(option.id);
        });
      }
    },
  },
};
</script>
